/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useContext, useEffect } from 'react';
import { Button, Input, Loader, Modal, Search } from '@scuf/common';
import descriptors from '../../locales/en-US/descriptors';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import { useTranslation } from '@scuf/localization';
import { useUtilityAccountContext } from '../../context/UtilityAccountContext/UtilityAccountContext';
import UtilityAccountAction from '../../context/UtilityAccountContext/UtilityAccountActions';
import './ConversionModalComponent.scss';
import useConnectorForPost from '../shared/useConnectorAndDynamicProps/useConnectorForPost';
// import { IAllConnectDetails, IUtilityProviders } from '../UtilityServiceModal/IUtilityService';
import { ApiContext } from '../../context/ApiContext';
import {
  getEnrollNotifyInfo,
  getConversionNotifyInfo
} from '../shared/Utils/UtilitySettings/UtilitySettingsUtils';
import {
  convertUtilityProvidersToOptions,
  debounce
} from '../shared/Utils/Utils';
import { MAGIC_VALUE } from '../shared/Utils/Constants';
import { connectorConfigCheck } from '../UtilityServiceModal/ConnectTab/ConnectTabUtils';
import useConnectorAndDynamicProps from '../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import { IResult } from '@scuf/common/dist/components/Search/ISearchProps';
import { isLoadingCheck } from '../shared/Utils/UtilityViewDetails';

function ConvertIntrgrationModal(props: IAny) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const [state, dispatch] = useUtilityAccountContext();
  const { showConversionModal, selectedUtility } = state;
  const [providerId, setProviderId] = useState<string>('');
  const [userDetails, setUserDetails] = useState({
    userName: '',
    password: ''
  });

  const [resultSelectedFromSearch, setResultSelectedFromSearch] = useState<
    boolean
  >(false);

  const [provCheckLoader, isProvCheckLoader] = useState<boolean>(false);

  const [isSearchDisable, setIsSearchDisable] = useState<boolean>(false);

  const [providerError, setProviderError] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const [selectedUtilityProvider, SetSelectedUtilityProvider] = useState<IAny>({
    utilityProviderName: ''
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [providerName, setProviderName] = useState<string>('');

  let { requestContext, bearerToken } = props;
  const [SearchKeyword, setSearchKeyword] = useState('');

  const connectorConfig = {
    name: 'manual-to-automatic-conversion'
  };

  const connectorConfigForSearch: IAny = {
    name: connectorConfigCheck(SearchKeyword, 1),
    options: {
      includeHbsmProviders: 'false'
    }
  };

  const requestContextForSearch = {
    ...requestContext,
    context: {
      ...requestContext.context,
      searchKeyword: SearchKeyword
    }
  };

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig: connectorConfigForSearch,
    requestContext: requestContextForSearch,
    bearerToken
  });

  const connectorConfigProviderCheck: IAny = {
    name: 'manual-to-automatic-service-provider'
  };

  const requestContextForProviderCheck = {
    ...requestContext,
    context: {
      ...requestContext.context,
      providerId: state.selectedUtility.providerId
    }
  };

  const dataConnectorProviderCheck: IAny = useConnectorAndDynamicProps({
    connectorConfig: connectorConfigProviderCheck,
    requestContext: requestContextForProviderCheck,
    bearerToken
  });

  const dataConnectorForSubmit: IAny = useConnectorForPost({
    connectorConfig,
    requestContext,
    bearerToken
  });

  useEffect(() => {
    if (showConversionModal) {
      setResultSelectedFromSearch(true);
      setIsLoading(true);
      isProvCheckLoader(true);
      dataConnectorProviderCheck &&
        dataConnectorProviderCheck[0].actions &&
        dataConnectorProviderCheck[0].actions.getAll();
    } else {
      setResultSelectedFromSearch(false);
    }
  }, [showConversionModal]);

  let IsProvExists =
    dataConnectorProviderCheck &&
    dataConnectorProviderCheck.length &&
    dataConnectorProviderCheck[0].data &&
    (dataConnectorProviderCheck[0].data.all as unknown);

  let isDataAvailableForProvCheck: IAny = '';
  if (IsProvExists && typeof IsProvExists === 'boolean') {
    isDataAvailableForProvCheck = true;
  } else if (!IsProvExists && typeof IsProvExists === 'boolean') {
    isDataAvailableForProvCheck = false;
  }

  useEffect(() => {
    SetSelectedUtilityProvider({
      utilityProviderName: state.selectedUtility.providerName
    });
  }, [state.selectedUtility]);

  useEffect(() => {
    if (IsProvExists && typeof IsProvExists === 'boolean') {
      isProvCheckLoader(false);
      setIsLoading(false);
      setProviderId(state.selectedUtility.providerId);
      setProviderName(state.selectedUtility.providerName);
      setIsSearchDisable(true);
    } else if (!IsProvExists && typeof IsProvExists === 'boolean') {
      isProvCheckLoader(false);
      setProviderError(true);
      setIsSearchDisable(false);
    }
  }, [IsProvExists, isDataAvailableForProvCheck]);

  const minimumSearchCharacter = 3;

  const [results, setResults] = useState<IResult[]>([]);

  useEffect(() => {
    // SetSelectedUtilityProvider({});
    setResults([]);
    // if (SearchKeyword.length >= minimumSearchCharacter) {
    dataConnector && dataConnector.actions && dataConnector.actions.getAll();
    // }
  }, [SearchKeyword]);

  const emaasContext = useContext(ApiContext);
  const apiContext = useContext(ApiContext);
  const { notifyMessage } = apiContext;
  const closeModal = () => {
    dispatch(UtilityAccountAction.hideConversionModal());
  };

  const handleChange = (value: string, name: string) => {
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleSubmit = async () => {
    isProvCheckLoader(true);
    setIsSubmitting(true);
    const requestBody = {
      utilityAccountId: selectedUtility.id,
      credential: btoa(`${userDetails.userName}:${userDetails.password}`),
      serviceProviderId: providerId,
      serviceProviderName: providerName
    };

    const result: IAny = await dataConnectorForSubmit.actions.create(
      requestBody
    );
    const { notifyDescription, notifyType } = getConversionNotifyInfo(result);
    closeModal();
    notifyMessage && notifyMessage(t(notifyDescription), notifyType);
  };
  const SearchProvider = async (value: string) => {
    setSearchKeyword(value.trim());
    // if (
    //   value.length <= MAGIC_VALUE.HUNDRED &&
    //   (props.utilityTyp === 'Manual')
    // ) {
    //   setSearchKeyword(value.trim());
    // }
  };

  const { all, loading, error, status } = dataConnector.data;
  const UtilityProviderResponse: IAny = (all as unknown) as IAny;
  let isDataAvailable: boolean;
  if (UtilityProviderResponse) isDataAvailable = true;
  else isDataAvailable = false;

  const debounceTimeLimit = 500;
  const debouncedSearch = debounce(SearchProvider, debounceTimeLimit);

  useEffect(() => {
    setIsLoading(loading);

    // if (!isDataAvailable && SearchKeyword && props.utilityTyp === 'Manual') {
    //   props.setIsSpecialCharacter(false);
    //   SetSelectedUtilityProvider({
    //     utilityProviderName: SearchKeyword,
    //     utilityProviderId: uuid4()
    //   });
    // }
    if ((isDataAvailable || error || status) && !loading) {
      if (isDataAvailable) {
        // setData(UtilityProviderResponse);

        // saveDataForManual();
        let UtilityProviders = convertUtilityProvidersToOptions(
          UtilityProviderResponse?.data
        );
        let searchresults = UtilityProviders.map((provider) => {
          return {
            title: provider.text,
            value: provider.value
          };
        });
        let filteredResults = searchresults.filter((searchEle) => {
          return searchEle.title
            .toLowerCase()
            .includes(SearchKeyword.toLowerCase());
        });
        setResults(filteredResults);
        // if(filteredResults && filteredResults.length === 0) {
        //   setProviderError(true);
        // } else {
        //   setProviderError(false);
        // }
      }
      // setErrorInfo(error);
      // setStatusCode(status);
    }
  }, [isDataAvailable, loading]);

  useEffect(() => {
    if (!showConversionModal) {
      setUserDetails({
        userName: '',
        password: ''
      });
    }
  }, [showConversionModal]);

  return (
    <Modal
      className="emaas-conversion-modal"
      size="large"
      closeIcon={true}
      onClose={closeModal}
      open={showConversionModal}
      closeOnDimmerClick={false}
    >
      <Modal.Header className="conversion-modal-header">
        {t(d.CONVERT_INTEGRATION_TYPE)}
      </Modal.Header>
      <Modal.Content className="conversion-modal-content">
        {provCheckLoader ? (
          <Loader
            loading={true}
            text={isSubmitting ? t(d.SUBMITTING) : t(d.LOADING)}
          />
        ) : (
          [
            <div className="conversion-centent-head">
              <div className="head-service-detail">
                <span className="detail-heading">{t(d.ServiceProvider)}</span>
                <span>{selectedUtility.providerName}</span>
              </div>
              <div className="head-account-detail">
                <span className="detail-heading">{t(d.AccountNumber)}</span>
                <span>{selectedUtility.accountNumber}</span>
              </div>
              <div className="head-utilityType-detail">
                <span className="detail-heading">{t(d.UtilityType)}</span>
                <span>{selectedUtility.utilityType}</span>
              </div>
            </div>,
            <div className="conversion-info-text">
              {t(d.CONVERSIONINFOMSG)}
            </div>,
            <div className="conversion-Search-provider">
              <div className="utility-provider-label">
                {t(d.UTILITYPROVIDERLABEL)}*
              </div>
              <Search
                placeholder={t(d.SEARCHPROVIDER)}
                noResultsMessage={isLoadingCheck(isLoading, t)}
                results={results}
                value={selectedUtilityProvider.utilityProviderName}
                disabled={isSearchDisable}
                onResultClear={() => {
                  setProviderError(true);
                }}
                onSearchChange={(value) => {
                  // setProviderError(false);
                  setResultSelectedFromSearch(false);
                  debouncedSearch(value);
                }}
                onMouseOut={() => {
                  if (
                    !UtilityProviderResponse.data ||
                    !resultSelectedFromSearch
                  ) {
                    setProviderError(true);
                  }
                }}
                onResultSelect={(value) => {
                  // setDisplaySelected(value.title);
                  setResultSelectedFromSearch(true);
                  setProviderError(false);
                  SetSelectedUtilityProvider(JSON.parse(value.value));
                  setProviderId(JSON.parse(value.value).utilityProviderId);
                  setProviderName(JSON.parse(value.value).utilityProviderName);
                }}
              />
              {providerError && (
                <span className="total-error">{t(d.UTILITYPROVIDERERROR)}</span>
              )}

              {/* <Input
            placeholder=""
            label={t(d.UTILITYPROVIDER)}
            indicator="required"
            value={userDetails.userName}
            onChange={(value) => handleChange(value, 'userName')}
          /> */}
            </div>,
            <div className="conversion-signin-username">
              <Input
                placeholder="thisisausername@constellation.com"
                label={t(d.USERNAME)}
                indicator="required"
                value={userDetails.userName}
                onChange={(value) => handleChange(value, 'userName')}
              />
            </div>,
            <div className="conversion-signin-password">
              <Input
                placeholder="xxxxxxxxxxx"
                label={t(d.PASSWORD)}
                type="password"
                disablePasswordToggle={true}
                indicator="required"
                value={userDetails.password}
                onChange={(value) => handleChange(value, 'password')}
              />
            </div>
          ]
        )}
      </Modal.Content>
      <Modal.Footer className="conversion-modal-footer">
        {!provCheckLoader && (
          <Button
            type="primary"
            content={t(d.SUBMIT)}
            onClick={handleSubmit}
            disabled={
              providerError ||
              !selectedUtilityProvider.utilityProviderName ||
              !userDetails.userName ||
              !userDetails.password
            }
          ></Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ConvertIntrgrationModal;
